// client/editors/Base.ts
import "@adornis/buildify/client/components/x-buildify-permission-selection.js";
import "@adornis/buildify/client/components/x-buildify-spacing-picker.js";
import "@adornis/chemistry/elements/components/x-flex";
import { html } from "lit";
var BaseEditor = ({ content, contentController, controllerBaseKeyPath, host }) => {
  return html`
    <x-flex space="sm">
      <x-buildify-spacing-picker
        select
        clearable
        placeholder="Innenabstand"
        ${contentController.field("padding")}
      ></x-buildify-spacing-picker>
      <x-buildify-spacing-picker
        select
        clearable
        placeholder="Außenabstand"
        ${contentController.field("margin")}
      ></x-buildify-spacing-picker>
      <x-buildify-permission-selection ${contentController.field("permission")}></x-buildify-permission-selection>
    </x-flex>
  `;
};
export {
  BaseEditor
};
